<template>
  <el-container class="HistoryDialog">
    <el-main class="p-0">
      <div>
        <ATable
          ref="table"
          v-loading="loading"          
          :placeholder="placeholder"
          :search_field="search_field"
          :height="480"
          :data="integrate_items"
          hide-button-excel
          hide-button-insert
          border
          hide-pagination
          @row-click="handleClickRow"
        >
          <div slot="search">
            <div class="inline">
              <APeriodSelector 
                ref="period" 
                value="2w"
                @change="handleChangePeriod" 
              />
            </div>
            <div class="inline">
              <el-button
                type="primary"
                size="mini"
                round
                v-shortkey="['f5']"
                @shortkey.native="handleClickSearch"
                @click="handleClickSearch"
              >검색(F5)</el-button>
            </div>
          </div>
          <el-table-column
            type="index"
            label="No"
            :index="handleIndex"
            :width="$width.index"
          />
          <el-table-column
            :prop="type_flag===1?'contract_date':'order_date'"
            :label="type_flag===1?'수주일':'발주일'"
            :width="$width.date"
          />
          <el-table-column
            prop="customer_name"
            label="거래처"
            width="200"
          />
          <el-table-column
            prop="code"
            :label="type_flag===1?'수주번호':'발주번호'"
            width="100"
          />
          <el-table-column
            prop="product_name"
            label="품목"
            show-overflow-tooltip
          />
          <el-table-column
            prop="size"
            :label="$t('lang.size')"
            :width="$width.size"
            show-overflow-tooltip
          />
          <el-table-column
            prop="amount"
            label="수량"
            class-name="cell-number"
            :width="$width.amount"
            :formatter="util.numberFormat"
          />
          <el-table-column
            prop="unit_name"
            label="단위"
            v-if="type_flag===2"
            :width="$width.unit_name"
          />
          <el-table-column
            prop="cost"
            label="단가"
            class-name="cell-number"
            :width="$width.price"
            :formatter="util.numberFormat"
          />
          <el-table-column
            prop="created_user_name"
            label="등록인"
            :width="$width.username"
          />          
          <div slot="right-bottom" style="height:20px;">
            <el-button class="close-button" @click="handleClickClose">{{$t('button.close')}} (Esc)</el-button>
          </div>
        </ATable>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import { form_container } from "@/common/mixins/form_container";

export default {
  name: "HistoryDialog",
  mixins: [form_container],
  data() {
    return {
      title: '주문이력',
      search_field: ['code', 'product_name'],
      placeholder: '',
      items: [],      
      loading: false,
      period: {},
      integrate_items: [],
    };
  },
  props: {    
    type_flag: {
      type: Number,
      required: true
    },
    customer_id: {
      type: Number,
      required: true
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.type_flag === 1) {      
      this.placeholder = '수주번호, 품목';
    } else if (this.type_flag === 2) {      
      this.placeholder = '발주번호, 품목';
    }
    
    this.$nextTick(() => this.loadData());
  },
  methods: {
    loadData() {
      this.loading = true;
      // let params = { customer_id: this.customer_id };
      let params = null;
      let api = this.type_flag===1 ? this.api.listContractDetail : this.api.listOrderDetail;
      api(this.period, params).then(res => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items = res.data;
        this.integrateItems();
      });
    },       
    integrateItems() {
      let temp_item = null;
      this.items.forEach(item => {
        temp_item = this.integrate_items.find(find_item => find_item.code === item.code);
        if (temp_item) {
          temp_item.count++;
          if (!temp_item.product_name_org) temp_item.product_name_org = temp_item.product_name;
          temp_item.product_name = temp_item.product_name_org + " 외 " + temp_item.count + "건";
          temp_item.amount += item.amount;
          temp_item.tax += item.tax;
          temp_item.cost += item.cost;
          temp_item.supply_price += item.supply_price;
        } else {
          item.count = 0;
          this.integrate_items.push(item);
        }
      });
    },   
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleChangePeriod(value) {
      this.period = value;
    },
    handleClickSearch() {
      if (!this.period.valid) { return; }      
      this.loadData();
    },
    handleClickRow(data) {
      let params = this.type_flag===1 ? data.contract_id : data.order_id;
      let api = this.type_flag===1 ? this.api.selectContract : this.api.selectOrder;
      api(params).then(res => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        /**
         * 선택된 발주 이력 항목의 details 정보들이 가지는 'status_flag' 값이 '2'일 경우,
         * 발주 등록된 후 입고 등록된 상태의 정보
         * 이 경우, 수주 등록은 가능하지만 수정 및 삭제는 불가능
         * 매출에서는 'status_flag' 값이 '2'일 경우, 매출 등록된 상태로 판단하기 때문에 수정 및 삭제가 불가능
         * 그래서 새로 수주 등록하는 details 정보이므로 'status_flag' 값을 '0'으로 설정
         */
        res.data.details.forEach(item => {
          item.status_flag = '0';
        });
        this.$emit('select', Object.assign({}, res.data))
      });
    },
    handleClickClose() {
      this.$emit("completed");
    },
    handelCompletedForm(result) {
      this.dialog_visible = false;
      if (!result) { return; }
      this.loadData();
    },
  },
};
</script>
